// src/pages/FAQsPage.jsx
import React, { useState } from 'react';
import PageHeader from './PageHeader';
import { useLanguage } from '../../context/LanguageContext';
import { FaQuestionCircle, FaChevronDown } from 'react-icons/fa';

const FAQsPage = () => {
  const { language } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const t = {
    English: {
      pageHeaderTitle: "FAQs",
      title: "Frequently Asked Questions",
      subtitle: "Find answers to common questions about ST MatchZone.",
      faqs: [
        { q: "How do I create a profile?", a: "Sign up with your email or phone, fill in your details, upload photos, and verify your profile for better matches." },
        { q: "Is my data safe?", a: "Yes! We use advanced encryption and never share your information without consent." },
        { q: "How does matching work?", a: "Our smart algorithm matches based on preferences, values, education, and horoscope compatibility." },
        { q: "Can I hide my profile?", a: "Yes, use privacy settings to control who sees your profile." },
        { q: "How to report a fake profile?", a: "Click the report button on the profile – our team reviews it within 24 hours." }
      ]
    },
    Tamil: {
      pageHeaderTitle: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      title: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      subtitle: "ST MatchZone பற்றிய பொதுவான கேள்விகளுக்கு பதில்களைக் கண்டறியுங்கள்.",
      faqs: [
        { q: "சுயவிவரத்தை எப்படி உருவாக்குவது?", a: "மின்னஞ்சல் அல்லது தொலைபேசியுடன் பதிவு செய்யுங்கள், விவரங்களை நிரப்புங்கள், புகைப்படங்களை பதிவேற்றுங்கள், சிறந்த இணைப்புகளுக்கு சரிபார்க்கவும்." },
        { q: "என் தரவு பாதுகாப்பானதா?", a: "ஆம்! மேம்பட்ட குறியாக்கத்தை பயன்படுத்துகிறோம், உங்கள் தகவலை ஒப்புதல் இல்லாமல் பகிர்வதில்லை." },
        { q: "இணைத்தல் எப்படி வேலை செய்கிறது?", a: "எங்கள் புத்திசாலி அல்காரிதம் விருப்பங்கள், மதிப்புகள், கல்வி மற்றும் ஜாதக பொருத்தத்தின் அடிப்படையில் இணைக்கிறது." },
        { q: "என் சுயவிவரத்தை மறைக்க முடியுமா?", a: "ஆம், தனியுரிமை அமைப்புகளை பயன்படுத்தி யார் பார்க்கிறார்கள் என்பதை கட்டுப்படுத்தலாம்." },
        { q: "போலி சுயவிவரத்தை எப்படி புகாரளிப்பது?", a: "சுயவிவரத்தில் புகாரளி பொத்தானை கிளிக் செய்யுங்கள் – எங்கள் குழு 24 மணி நேரத்தில் மதிப்பாய்வு செய்யும்." }
      ]
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader showBackButton={true} backTo="/" title={txt.pageHeaderTitle} />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <img src="https://kenosiscenter.com/wp-content/uploads/2022/08/Kenosis-blog-image-1.png" alt="FAQs" className="w-full h-96 object-cover rounded-2xl shadow-xl mb-10" />
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">{txt.title}</h1>
          <p className="text-xl text-gray-600">{txt.subtitle}</p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {txt.faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-rose-50 transition"
              >
                <div className="flex items-center gap-4">
                  <FaQuestionCircle className="text-2xl text-rose-600" />
                  <h3 className="text-xl font-bold text-gray-900">{faq.q}</h3>
                </div>
                <FaChevronDown className={`text-rose-600 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6 text-gray-700 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;